import React from "react";
import { dataAboutMe, dataProfile } from "../../../dataPortfolio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Landing = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 dark:from-slate-900 dark:via-slate-800 dark:to-black text-slate-900 dark:text-white font-sans p-4 transition-colors duration-500">
    <div className="w-full max-w-lg bg-white/60 dark:bg-white/10 backdrop-blur-xl border border-white/40 dark:border-white/20 shadow-2xl rounded-[2.5rem] p-8 md:p-12 flex flex-col items-center gap-8 transition-colors duration-500">
      <header className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-500 dark:from-blue-400 dark:to-indigo-300">
          {dataProfile.titleProfileHighlight}
        </h1>
        <p className="text-lg md:text-xl text-slate-600 dark:text-slate-300 font-medium tracking-wide uppercase">
          {dataProfile.description}
        </p>
      </header>

      <main className="flex flex-col items-center gap-8 w-full">
        <div className="relative group cursor-pointer" tabIndex={0}>
          <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-400 to-indigo-400 dark:from-blue-500 dark:to-indigo-500 rounded-full blur opacity-50 group-hover:opacity-100 group-active:opacity-100 focus:opacity-100 transition duration-500"></div>
          <div className="relative rounded-full w-40 h-40 overflow-hidden ring-4 ring-white shadow-2xl dark:ring-white/20 transition-transform duration-500 group-hover:scale-105 group-active:scale-105 focus:scale-105">
            <img
              src={dataProfile.profileImage}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="text-center text-slate-700 dark:text-slate-300 space-y-4 text-base md:text-lg font-light leading-relaxed">
          {dataAboutMe.knowMeDescriptions.map((description, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: description }} />
          ))}
        </div>

        <div className="flex gap-6 mt-4">
          {dataProfile.socialMedia.map((sMedia, index) => (
            <a
              key={index}
              href={sMedia.redirectLink}
              target="_blank"
              rel="noreferrer"
              className="text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white hover:-translate-y-1 hover:scale-110 transition-all duration-300"
            >
              <FontAwesomeIcon icon={sMedia.icon} size="2x" />
            </a>
          ))}
          <a
            href={dataProfile.emailAdress}
            className="text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white hover:-translate-y-1 hover:scale-110 transition-all duration-300"
            aria-label="Email"
          >
            <div className="flex items-center justify-center w-[32px] h-[32px]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="w-7 h-7">
                <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
              </svg>
            </div>
          </a>
        </div>
      </main>
    </div>
  </div>
);

export default Landing;
